/* Safari 16/17 cannot reliably resolve relative system colours in embedded
 * account UI. Keep that UI inert, rather than hiding it after initialization.
 * A normal account link also remains available without JavaScript. */
(() => {
  if (customElements.get('lt-account-compat')) return;
  const safari = /Version\/(\d+)[\d.]*.*Safari\//.exec(navigator.userAgent);
  const legacySafari = Boolean(safari && Number(safari[1]) < 18);
  customElements.define('lt-account-compat', class extends HTMLElement {
    connectedCallback() {
      if (legacySafari || this.querySelector('shopify-account')) return;
      const template = this.querySelector('template[data-account-enhanced]');
      const fallback = this.querySelector('[data-account-fallback]');
      if (!template || !fallback) return;
      this.appendChild(template.content.cloneNode(true));
      fallback.hidden = true;
    }
  });
})();
